import { createMachine } from 'xstate';
import { actions } from './actions.js';

var treeStateMachine = createMachine({
    predictableActionArguments: true,
    id: "tree",
    initial: "idle",
    entry: ["setNodeOrder"],
    on: {
        click: {
            actions: ["setActiveNode", "toggleChildren", "setNodeOrder"],
        },
        mouseenter: { actions: "setActiveNode" },
        mouseleave: { actions: "unsetActiveNode" },
        setNodes: { actions: ["setNodes", "setNodeOrder"] },
    },
    states: {
        idle: {
            on: {
                FOCUS: {
                    actions: ["setDefaultActiveNode"],
                    target: "active",
                },
                KEYBOARD_FOCUS: {
                    actions: ["setDefaultActiveNode"],
                    target: "active",
                },
            },
        },
        active: {
            on: {
                BLUR: { target: "idle" },
                keyDownArrowDown: { actions: ["moveActiveNodeDown"] },
                keyDownArrowUp: { actions: ["moveActiveNodeUp"] },
                keyDownArrowRight: { actions: ["rightKeyPressed"] },
                keyDownArrowLeft: { actions: ["leftKeyPressed"] },
                keyDownEnd: { actions: ["moveActiveToLast"] },
                keyDownHome: { actions: ["moveActiveToFirst"] },
                keyDownSpace: {
                    actions: [""],
                },
                keyDownEnter: [{ actions: [""] }],
                keyDownEscape: { target: "idle" },
            },
        },
    },
}, 
// use single select actions by default
// useSelectStateMachine will override where appropriate
{ actions: actions });

export { treeStateMachine };
//# sourceMappingURL=treeStateMachine.js.map
